import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHouse3Floor = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "100%",
	height: "100%",
	viewBox: "0 0 53 73",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M4.85449 52.3494H48.8083V67.9064H44.2567V56.2216H33.9306V67.9064H4.85449V52.3494Z",
			stroke: "#808080",
			strokeWidth: 1.2
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 32.1332,
			height: 3.87228,
			transform: "matrix(1 0 0 -1 1.79785 71.7787)",
			stroke: "#808080",
			strokeWidth: 1.2
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 7.54076,
			height: 3.87228,
			transform: "matrix(1 0 0 -1 44.2568 71.7787)",
			stroke: "#808080",
			strokeWidth: 1.2
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 50,
			height: 3.87228,
			transform: "matrix(1 0 0 -1 1.79785 52.3494)",
			stroke: "#808080",
			strokeWidth: 1.2
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 50,
			height: 3.87228,
			transform: "matrix(1 0 0 -1 1.79785 32.92)",
			stroke: "#808080",
			strokeWidth: 1.2
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M33.6934 71.7787H44.529",
			stroke: "#808080",
			strokeWidth: 1.2
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 13.1114,
			height: 7.09918,
			transform: "matrix(1 0 0 -1 10.4004 63.3547)",
			stroke: "#808080",
			strokeWidth: 1.2
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.9561 63.3547V56.2556",
			stroke: "#808080",
			strokeWidth: 1.2
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.25195 63.3547L25.6602 63.3547",
			stroke: "#808080",
			strokeWidth: 1.2
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.85449 32.92H48.8083V48.4771H4.85449V32.92Z",
			stroke: "#808080",
			strokeWidth: 1.2
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 13.1114,
			height: 7.09918,
			transform: "matrix(1 0 0 -1 10.3994 43.9257)",
			stroke: "#808080",
			strokeWidth: 1.2
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.9551 43.9257V36.8265",
			stroke: "#808080",
			strokeWidth: 1.2
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.25098 43.9257L25.6593 43.9257",
			stroke: "#808080",
			strokeWidth: 1.2
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 13.1114,
			height: 7.09918,
			transform: "matrix(1 0 0 -1 30.084 43.9257)",
			stroke: "#808080",
			strokeWidth: 1.2
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M36.6396 43.9257V36.8265",
			stroke: "#808080",
			strokeWidth: 1.2
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M27.9355 43.9257L45.3438 43.9257",
			stroke: "#808080",
			strokeWidth: 1.2
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.85449 13.4906H48.8083V29.0477H4.85449V13.4906Z",
			stroke: "#808080",
			strokeWidth: 1.2
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 9.03533,
			height: 9.1712,
			transform: "matrix(1 0 0 -1 33.8633 10.2297)",
			stroke: "#808080",
			strokeWidth: 1.2
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M33.8631 5.27049H7.23263L1.79785 13.4906H51.7979L46.3631 5.27049H42.8984",
			stroke: "#808080",
			strokeWidth: 1.2
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 13.1114,
			height: 7.09918,
			transform: "matrix(1 0 0 -1 10.4004 24.4961)",
			stroke: "#808080",
			strokeWidth: 1.2
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.9561 24.4961V17.3969",
			stroke: "#808080",
			strokeWidth: 1.2
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.25195 24.4961L25.6602 24.4961",
			stroke: "#808080",
			strokeWidth: 1.2
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 13.1114,
			height: 7.09918,
			transform: "matrix(1 0 0 -1 30.084 24.4961)",
			stroke: "#808080",
			strokeWidth: 1.2
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M36.6396 24.4961V17.3969",
			stroke: "#808080",
			strokeWidth: 1.2
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M27.9355 24.4961L45.3438 24.4961",
			stroke: "#808080",
			strokeWidth: 1.2
		})
	]
});
const ForwardRef = forwardRef(SvgHouse3Floor);
export default ForwardRef;
